import request from '@/utils/request'

export function getBusinessTodoCounts() {
  return request({
    url: '/pc-api/businessFlow/todo/counts',
    method: 'get'
  })
}
